import React, { useEffect, useState } from "react";
import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { faListUl, faShoppingBasket, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Style from "./BottomNavigation.module.css";
import { Link } from "react-router-dom";
const BottomNavigation = () => {
  useEffect(() => {
    if (
      window.location.pathname === "/deliverypanel/ordercondition" ||
      window.location.pathname === "/taxireq/taxireqcondition"
    ) {
      setOrderList(false);
      setProfile(false);
      setCondition(true);
    }
    if (
      window.location.pathname === "/deliverypanel" ||
      (window.location.pathname === "/taxireq")
    ) {
      setOrderList(true);
      setProfile(false);
      setCondition(false);
    }
    if (window.location.pathname === "/profile") {
      setOrderList(false);
      setProfile(true);
      setCondition(false);
    }
  }, [window.location.pathname]);

  const [orderList, setOrderList] = useState(false);
  const [profile, setProfile] = useState(true);
  const [condition, setCondition] = useState(false);
  const pathname=window.location.pathname.split('/')[1]
  return (
    <nav className={Style.NavbarHolder}>
      <Link 
      to={pathname === "taxireq" ? "/taxireq/profile" : "/deliverypanel/profile"}
      className={profile ? Style.onFocus : null}>
        <FontAwesomeIcon icon={faAddressCard} />
        پروفایل
      </Link>
      <Link
        to={pathname === "taxireq" ? "/taxireq" : "/deliverypanel"}
        className={orderList ? Style.onFocus : null}
      >
        <FontAwesomeIcon icon={faListUl} />
        درخواست ها
      </Link>
      <Link
        to={pathname === "taxireq" ? "/taxireq/taxireqcondition" : "/deliverypanel/ordercondition"}
        className={condition ? Style.onFocus : null}
      >
        <FontAwesomeIcon icon={faShoppingBasket} />
        وضعیت درخواست
      </Link>
      <Link
        to={'/'}
      >
        <FontAwesomeIcon icon={faSignOutAlt} />
         تغییر پنل
      </Link>
    </nav>
  );
};

export default BottomNavigation;
